<template>
  <div>
    <template>
      <v-layout>
        <v-flex grow style="flex-basis: 300px">
          <v-layout class="location-group-list">
            <v-flex class="subheader" xs7>設定可能な地点グループ一覧</v-flex>
            <v-flex class="location-group-buttons" xs5>
              <div>
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <div
                      v-on="on"
                      @click="openLocationTab"
                      class="location-group-button"
                    >
                      <v-icon color="primary" small>open_in_new</v-icon>
                      <span class="location-group-button-text">追加</span>
                    </div>
                  </template>
                  <span>地点グループ追加のタブを開く</span>
                </v-tooltip>
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <div
                      v-on="on"
                      @click="fetchLocationGroups"
                      class="location-group-button location-group-button-refresh"
                    >
                      <v-icon small>refresh</v-icon>
                      更新
                    </div>
                  </template>
                  <span>地点グループ一覧を更新する</span>
                </v-tooltip>
              </div>
            </v-flex>
          </v-layout>
          <v-layout class="group-filter">
            <v-flex xs5>グループ種別</v-flex>
            <v-flex>
              <v-select
                v-model="selectableLocationGroupFilterType"
                :items="groupTypes"
                item-text="text"
                item-value="type"
              />
            </v-flex>
          </v-layout>
          <v-layout class="search-box-layer">
            <v-flex style="z-index: 1;" xs4>
              <v-text-field
                v-model="keyword0"
                @input="inputKeyword(0)"
                @keypress.enter.exact="shiftSearchItem(0, 1)"
                @keypress.enter.shift="shiftSearchItem(0, -1)"
                class="search-box"
                append-icon="search"
                placeholder="検索"
                background-color="white"
                solo
                hide-details
              >
                <template v-slot:append v-if="searchCount0">
                  <div>{{ searchIndex0 + 1 }}/{{ searchCount0 }}</div>
                  <v-icon @click="shiftSearchItem(0, -1)" small
                    >arrow_upward</v-icon
                  >
                  <v-icon @click="shiftSearchItem(0, 1)" small
                    >arrow_downward</v-icon
                  >
                </template>
              </v-text-field>
            </v-flex>
            <v-flex class="inline-block" style="z-index: 1" xs4>
              <v-btn
                v-if="isAllLocationGroupsSelected()"
                @click="clearSelection"
              >
                選択を解除
              </v-btn>
              <v-btn v-else @click="selectAllToggle">すべて選択</v-btn>
            </v-flex>
          </v-layout>
          <v-tabs v-model="activeTab" style="margin-top: -48px">
            <template v-for="type in types" else>
              <v-tab :key="type" @click="clearSelection">{{
                typeText(type)
              }}</v-tab>
              <v-tab-item :key="`${type}-body`">
                <template v-if="loading">
                  <v-flex style="height: 100px">
                    <v-btn loading flat style="width: 100%; height: 100%;" />
                  </v-flex>
                </template>
                <template v-else>
                  <div class="select-box">
                    <div
                      :ref="`selector0${Tabs[type]}`"
                      class="locationGroupList"
                    >
                      <div
                        v-for="item in filteredSelectableLocationGroups[type]"
                        :key="item.id"
                        :value="item"
                        @click.prevent="toggleSelect(item)"
                        @dblclick.prevent="instantMoveToRight(item)"
                        :class="[
                          'locationGroup pl-2',
                          {
                            isSelected: item.selected,
                            isSimulation: item.type === 'simulation',
                            'font-italic grey--text': !item.isUsable,
                          },
                        ]"
                      >
                        <v-flex
                          :ref="`option0${Tabs[type]}`"
                          xs8
                          class="location-group-name"
                          >{{ item.name }}（{{
                            getLocationCount(item)
                          }}
                          地点）</v-flex
                        >
                        <v-flex xs4 class="location-group-type">{{
                          groupTypes.find(
                            type => type.type === item.locationType,
                          ).text
                        }}</v-flex>
                      </div>
                    </div>
                  </div>
                </template>
              </v-tab-item>
            </template>
          </v-tabs>
        </v-flex>
        <v-flex
          justify-center
          align-self-center
          shrink
          style="padding-top: 15%;"
        >
          <v-layout column>
            <v-btn
              :disabled="deliveryLocationGroupsIsFull"
              @click="moveGroupsToRight"
              icon
              large
            >
              <v-icon x-large>arrow_right</v-icon>
            </v-btn>
            <v-btn @click="moveGroupsToLeft" icon large>
              <v-icon x-large>arrow_left</v-icon>
            </v-btn>
          </v-layout>
        </v-flex>
        <v-flex grow style="flex-basis: 300px;">
          <v-layout class="location-group-list-add">
            <v-flex class="subheader" xs7>配信地点グループ</v-flex>
          </v-layout>
          <v-layout class="group-filter">
            <v-flex xs5>グループ種別</v-flex>
            <v-flex>
              <v-select
                v-model="deliveryLocationGroupFilterType"
                :items="groupTypes"
                item-text="text"
                item-value="type"
              />
            </v-flex>
          </v-layout>
          <v-layout class="search-box-layer">
            <v-flex style="z-index: 1;" xs8>
              <v-text-field
                v-model="keyword1"
                @input="inputKeyword(1)"
                @keypress.enter.exact="shiftSearchItem(1, 1)"
                @keypress.enter.shift="shiftSearchItem(1, -1)"
                class="search-box"
                append-icon="search"
                placeholder="検索"
                background-color="white"
                solo
                hide-details
              >
                <template v-slot:append v-if="searchCount1">
                  <div>{{ searchIndex1 + 1 }}/{{ searchCount1 }}</div>
                  <v-icon @click="shiftSearchItem(1, -1)" small
                    >arrow_upward</v-icon
                  >
                  <v-icon @click="shiftSearchItem(1, 1)" small
                    >arrow_downward</v-icon
                  >
                </template>
              </v-text-field>
            </v-flex>
            <v-flex class="inline-block" xs4>
              <v-btn
                v-if="isAllDeliveryLocationGroupsSelected()"
                @click="clearDeliveryLocationGroupsSelection"
              >
                選択を解除
              </v-btn>
              <v-btn v-else @click="selectAllToggleDeliveryLocationGroup"
                >すべて選択</v-btn
              >
            </v-flex>
          </v-layout>
          <div class="select-box">
            <div :ref="`selector1`" class="locationGroupList">
              <div
                v-for="item in filteredDeliveryLocationGroups"
                :key="item.id"
                :value="item"
                @click.prevent="onClickDeliveryLocationGroup(item)"
                :class="[
                  'locationGroup pl-2',
                  {
                    added: hasSimulationLocationGroup,
                    isSelected: item.selected,
                    isSimulation: item.leftGroup.type === 'simulation',
                  },
                ]"
              >
                <v-flex ref="option1" xs8 class="location-group-name">
                  {{ item.name }}（{{ getDeliveryLocationCount(item) }} 地点）
                </v-flex>
                <v-flex xs4 class="location-group-type">{{
                  item.locationType
                    ? groupTypes.find(type => type.type === item.locationType)
                        .text
                    : groupTypes.find(
                        type => type.type === item.leftGroup.locationType,
                      ).text
                }}</v-flex>
              </div>
            </div>
          </div>
          <small
            v-if="hasSimulationLocationGroup"
            class="grey--text d-block mb-2"
          >
            配信地点グループに設定した地点グループのうち、シミュレーションから読み込まれたグループ
            （<v-icon class="simulation-point-icon">fiber_manual_record</v-icon
            >）は、新規で案件地点グループとして保存されます。
          </small>
          <small class="grey--text d-block">
            配信地点グループの個数の規定については各個別契約に準拠します。詳しくはヘルプマニュアルをご参照ください。
          </small>
          <small
            v-if="isLimitOverDeliveryLocationGroups"
            class="red--text d-block"
          >
            現在、配信地点グループの設定上限を一時的に60グループまでとさせていただいております。
            61グループを超えて設定される場合、別途キャンペーンを作成して登録して下さい。
            選択した配信地点グループ数: {{ deliveryLocationGroups.length }}
          </small>
        </v-flex>
      </v-layout>
    </template>
  </div>
</template>

<script>
import { Campaign } from '@/models/CampaignOperation'
import {
  actions as snackbarActions,
  snackbarType,
} from '@/vuex/modules/ui/snackbar/constants'
import { locationGroupType } from '@/components/Advertiser/Operation/PointGroup/PointGroupOperation/constants'
import debounce from 'lodash/debounce'
import { mapGetters } from 'vuex'

// 左列（地点グループリスト）で扱いやすいようにする
/**
 * @param {array} 地点グループリスト
 * @param {string} 地点グループリストの所属先（oem|advertiser|insertionOrder)
 */
const wrapLocationGroups = (arr, type) => {
  const locationGroupToLeftGroup = (group, index) => ({
    id: group.id,
    name: group.name,
    isUsable: group.isUsable,
    index,
    type,
    locationCount: group.locationCount,
    activeLocationCount: group.activeLocationCount,
    accessibleType: group.accessibleType,
    locationType: group.locationType,
    selected: false,
    moved: false,
  })
  return arr.map(locationGroupToLeftGroup)
}
// 右列（配信地点グループリスト）で扱いやすいようにする
const leftGroupToRightGroup = (group, index) => ({
  id: group.id,
  name: group.name,
  accessibleType: group.accessibleType,
  locationType: group.locationType,
  locationCount: group.locationCount,
  activeLocationCount: group.activeLocationCount,
  selected: false,
  index,
  leftGroup: group,
})
// form.deliveryLocationGroups の形式に合わせる
const rightGroupToDeliveryLocationGroup = group => ({
  locationGroupId: group.id,
  name: group.name,
  accessibleType: group.accessibleType,
  locationType: group.locationType,
  locationCount: group.locationCount,
  activeLocationCount: group.activeLocationCount,
})

export default {
  name: 'CampaignModalPageGeoGroupSelect',
  props: {
    oemLocationGroups: {
      type: Array,
      default: () => [],
    },
    advertiserLocationGroups: {
      type: Array,
      default: () => [],
    },
    insertionOrderLocationGroups: {
      type: Array,
      default: () => [],
    },
    simulationLocationGroups: {
      type: Array,
      default: () => [],
    },
    currentDeliveryLocationGroups: {
      type: Array,
      default: () => [],
    },
    loading: Boolean,
    isLimitOverDeliveryLocationGroups: Boolean,
  },
  data() {
    return {
      locationGroups: {
        // oem: [],
        advertiser: [],
        insertionOrder: [],
        simulation: [],
      },
      deliveryLocationGroups: [],
      activeTab: null,
      clickCount: 0,
      timer: null,
      delay: 250,
      selectableLocationGroupFilterType: locationGroupType.ALL,
      deliveryLocationGroupFilterType: locationGroupType.ALL,
      // 検索機能２つ分の状態 数字はsearchBoxIndexと対応
      keyword0: '',
      searchIndex0: 0,
      searchCount0: null,
      keyword1: '',
      searchIndex1: 0,
      searchCount1: null,
    }
  },
  computed: {
    ...mapGetters('campaign', ['getLocationsById']),
    Tabs() {
      return {
        advertiser: 0,
        insertionOrder: 1,
        simulation: 2,
      }
    },
    types() {
      const allTypes = Object.keys(this.locationGroups)
      return this.hasSimulationLocationGroup
        ? allTypes
        : allTypes.filter(type => type !== 'simulation')
    },
    groupTypes() {
      return [
        { type: locationGroupType.ALL, text: 'すべて' },
        { type: locationGroupType.CUSTOM_LOCATION, text: '地点個別指定' },
        { type: locationGroupType.POI_LOCATION, text: '地点カテゴリー' },
      ]
    },
    deliveryLocationGroupsIsFull() {
      return (
        this.deliveryLocationGroups.length >=
        Campaign.deliveryLocationGroups.maxSize
      )
    },
    filteredDeliveryLocationGroups() {
      if (this.deliveryLocationGroupFilterType === locationGroupType.ALL)
        return this.deliveryLocationGroups
      return this.deliveryLocationGroups.filter(g => {
        return (
          g.locationType === this.deliveryLocationGroupFilterType ||
          g.leftGroup.locationType === this.deliveryLocationGroupFilterType
        )
      })
    },
    filteredSelectableLocationGroups() {
      if (this.selectableLocationGroupFilterType === locationGroupType.ALL)
        return this.selectableLocationGroups
      return Object.keys(this.selectableLocationGroups).reduce((acc, type) => {
        acc[type] = this.selectableLocationGroups[type].filter(
          g => g.locationType === this.selectableLocationGroupFilterType,
        )
        return acc
      }, {})
    },
    selectedLocationGroups() {
      return Object.keys(this.locationGroups).reduce((acc, type) => {
        return acc.concat(this.locationGroups[type].filter(g => g.selected))
      }, [])
    },
    selectableLocationGroups() {
      return Object.keys(this.locationGroups).reduce((acc, type) => {
        acc[type] = this.locationGroups[type].filter(g => !g.moved)
        return acc
      }, {})
    },
    selectedDeliveryLocationGroups() {
      return this.deliveryLocationGroups.filter(g => g.selected)
    },
    hasSimulationLocationGroup() {
      return this.simulationLocationGroups.length > 0
    },
  },
  watch: {
    loading(now, prev) {
      // ローディング終了時に初期化を行う
      if (prev && !now) {
        this.initLocationGroups()
        this.initDeliveryLocationGroups()
      }
    },
    selectedDeliveryLocationGroups() {
      this.$emit(
        'select',
        this.selectedDeliveryLocationGroups.map(
          rightGroupToDeliveryLocationGroup,
        ),
      )
    },
    selectableLocationGroupFilterType() {
      this.clearSelection()
      this.clearKeyword(0)
      this.putOnHighLightTag(0)
    },
    deliveryLocationGroupFilterType() {
      this.clearDeliveryLocationGroupsSelection()
      this.clearKeyword(1)
      this.putOnHighLightTag(1)
    },
    activeTab(newValue, oldValue) {
      if (oldValue === null) return
      const locationGroupsSpanTagList = this.$refs[`option0${oldValue}`] || []
      locationGroupsSpanTagList.forEach(option => {
        // spanタグがあれば、取り除く
        option.innerHTML = option.innerHTML.replace(
          /<span style="background-color: #[0-9a-fA-F]+;">/,
          '',
        )
        option.innerHTML = option.innerHTML.replace(/<\/span>/g, '')
        option.classList.remove(`has-keyword-0`)
      })
      this.clearKeyword(0)
    },
  },
  created() {
    this.setInitialActiveTab()
  },
  methods: {
    setInitialActiveTab() {
      this.activeTab = this.hasSimulationLocationGroup
        ? this.Tabs.simulation
        : this.Tabs.advertiser
    },
    initLocationGroups() {
      // this.locationGroups.oem = wrapLocationGroups(
      //   this.oemLocationGroups,
      //   'oem',
      // )
      this.locationGroups.advertiser = wrapLocationGroups(
        this.advertiserLocationGroups,
        'advertiser',
      )
      this.locationGroups.insertionOrder = wrapLocationGroups(
        this.insertionOrderLocationGroups,
        'insertionOrder',
      )
      this.locationGroups.simulation = wrapLocationGroups(
        this.simulationLocationGroups,
        'simulation',
      )
    },
    initDeliveryLocationGroups() {
      const locationGroups = this.currentDeliveryLocationGroups
        .map(deliveryLocationGroup =>
          this.getLocationGroup(deliveryLocationGroup.locationGroupId),
        )
        .filter(g => g)
      this.deliveryLocationGroups = locationGroups.map((locationGroup, i) => {
        return {
          id: locationGroup.id,
          name: locationGroup.name,
          selected: false,
          index: i,
          leftGroup: locationGroup,
        }
      })
      if (this.deliveryLocationGroups.length === 0) {
        this.deliveryLocationGroups = []
      }
      this.deliveryLocationGroups.forEach(deliveryLocationGroups =>
        this.toggleMoved(deliveryLocationGroups.leftGroup),
      )
    },
    typeText(type) {
      switch (type) {
        case 'oem':
          return '共通'
        case 'advertiser':
          return '広告主'
        case 'insertionOrder':
          return '案件'
        case 'simulation':
          return 'シミュレーション'
      }
    },
    toggleSelect(item) {
      const currentItem = this.locationGroups[item.type][item.index]
      this.locationGroups[item.type].splice(item.index, 1, {
        ...currentItem,
        selected: !currentItem.selected,
      })
    },
    clearSelection() {
      Object.keys(this.locationGroups).forEach(type => {
        const groups = this.locationGroups[type]
        groups.forEach(item => (item.selected = false))
      })
    },
    clearDeliveryLocationGroupsSelection() {
      this.deliveryLocationGroups.map(g => (g.selected = false))
    },
    toggleMoved(item) {
      const currentItem = this.locationGroups[item.type][item.index]
      this.locationGroups[item.type].splice(item.index, 1, {
        ...currentItem,
        moved: !currentItem.moved,
      })
      this.clearSelection()
    },
    toggleDeliveryLocationGroupSelect(item) {
      const currentItem = this.deliveryLocationGroups[item.index]
      this.deliveryLocationGroups.splice(item.index, 1, {
        ...currentItem,
        selected: !currentItem.selected,
      })
    },
    selectAllToggle() {
      if (this.activeTab === 0) {
        if (this.selectableLocationGroupFilterType === locationGroupType.ALL) {
          this.selectableLocationGroups.advertiser.map(g => (g.selected = true))
          return
        }
        this.selectableLocationGroups.advertiser.map(g => {
          if (g.locationType === this.selectableLocationGroupFilterType)
            g.selected = true
        })
      }
      if (this.activeTab === 1) {
        if (this.selectableLocationGroupFilterType === locationGroupType.ALL) {
          this.selectableLocationGroups.insertionOrder.map(
            g => (g.selected = true),
          )
          return
        }
        this.selectableLocationGroups.insertionOrder.map(g => {
          if (g.locationType === this.selectableLocationGroupFilterType)
            g.selected = true
        })
      }
    },
    selectAllToggleDeliveryLocationGroup() {
      if (this.deliveryLocationGroupFilterType === locationGroupType.ALL) {
        this.deliveryLocationGroups.map(g => (g.selected = true))
        return
      }
      this.deliveryLocationGroups.map(g => {
        if (
          g.locationType === this.deliveryLocationGroupFilterType ||
          g.leftGroup.locationType === this.deliveryLocationGroupFilterType
        )
          g.selected = true
      })
    },
    getLocationGroup(id) {
      const types = Object.keys(this.locationGroups)
      for (const i in types) {
        const type = types[i]
        const index = this.locationGroups[type].findIndex(g => g.id === id)
        if (index !== -1) return this.locationGroups[type][index]
      }
    },
    getLocationCount(group) {
      if (group.type === 'simulation') {
        return this.getLocationsById(group.id).filter(
          location => location.status === 'active',
        ).length
      }
      return group.activeLocationCount
    },
    getDeliveryLocationCount(group) {
      if (group.leftGroup.type === 'simulation') {
        return this.getLocationsById(group.leftGroup.id).filter(
          location => location.status === 'active',
        ).length
      }
      return group.leftGroup.activeLocationCount
    },
    hasNotUsableGroup(selectedGroups) {
      return selectedGroups.some(group => !group.isUsable)
    },
    validateMoveToRight() {
      if (this.deliveryLocationGroupsIsFull) return false
      const selectedLocationGroups = this.selectedLocationGroups

      if (this.hasNotUsableGroup(selectedLocationGroups)) {
        this.$confirm(
          `使用できない地点グループが含まれています。\n使用可能な地点グループのみ選択してください。`,
          { onlyOk: true, okText: '閉じる' },
        )
        return false
      }
      const maxSize = Campaign.maxDeliveryLocationGroups
      const currentSize = this.deliveryLocationGroups.length
      const expectSize = currentSize + selectedLocationGroups.length
      if (expectSize > maxSize) {
        this.$store.dispatch(snackbarActions.SHOW_SNACKBAR, {
          type: snackbarType.ERROR,
          message: `配信地点グループは最大${maxSize}個まで設定可能です。${expectSize -
            maxSize}個減らしてください。`,
        })
        return false
      }
      return true
    },
    moveGroupsToRight() {
      if (!this.validateMoveToRight()) return
      const selectedLocationGroups = this.selectedLocationGroups
      const currentSize = this.deliveryLocationGroups.length
      const newGroups = selectedLocationGroups.map((group, index) =>
        leftGroupToRightGroup(group, currentSize + index),
      )
      this.deliveryLocationGroups = [
        ...this.deliveryLocationGroups,
        ...newGroups,
      ]
      selectedLocationGroups.forEach(g => {
        this.toggleSelect(g)
        this.toggleMoved(g)
      })
      this.emitAdd(newGroups)
      this.clearKeyword(0)
      this.putOnHighLightTag(0)
    },
    moveGroupsToLeft() {
      const selectedDeliveryLocationGroups = [
        ...this.selectedDeliveryLocationGroups,
      ]
      selectedDeliveryLocationGroups.forEach(g => {
        this.toggleMoved(g.leftGroup)
        const index = this.deliveryLocationGroups.findIndex(
          group => group.id === g.id,
        )
        this.deliveryLocationGroups.splice(index, 1)
      })
      this.reIndexDeliveryLocationGroups()
      this.emitRemove(selectedDeliveryLocationGroups)
      this.clearKeyword(1)
      this.putOnHighLightTag(1)
    },
    instantMoveToRight(item) {
      this.clearSelection()
      this.toggleSelect(item)
      this.moveGroupsToRight()
    },
    instantMoveToLeft(item) {
      this.clearSelection()
      this.toggleDeliveryLocationGroupSelect(item)
      this.moveGroupsToLeft()
    },
    onClickDeliveryLocationGroup(item) {
      this.clickCount++
      if (this.clickCount === 1) {
        // クリック時
        this.timer = setTimeout(() => {
          this.toggleDeliveryLocationGroupSelect(item)
          this.clickCount = 0
        }, this.delay)
      } else {
        // ダブルクリック時
        clearTimeout(this.timer)
        this.instantMoveToLeft(item)
        this.clickCount = 0
      }
    },
    reIndexDeliveryLocationGroups() {
      this.deliveryLocationGroups = this.deliveryLocationGroups.map(
        (group, index) => ({
          ...group,
          index,
        }),
      )
    },
    emitRemove(deliveryLocationGroups) {
      this.$emit(
        'remove',
        deliveryLocationGroups.map(rightGroupToDeliveryLocationGroup),
      )
    },
    emitAdd(deliveryLocationGroups) {
      this.$emit(
        'add',
        deliveryLocationGroups.map(rightGroupToDeliveryLocationGroup),
      )
    },
    fetchLocationGroups() {
      this.$emit('fetch')
    },
    openLocationTab() {
      window.open(location.pathname.replace('insertion_orders', 'point_groups'))
    },
    isAllLocationGroupsSelected() {
      if (this.activeTab === 0)
        return this.isAllAdvertiserLocationGroupsSelected()
      if (this.activeTab === 1)
        return this.isAllInsertionOrderLocationGroupsSelected()
      return false
    },
    isAllAdvertiserLocationGroupsSelected() {
      if (this.filteredSelectableLocationGroups.advertiser.length === 0)
        return false
      if (
        this.filteredSelectableLocationGroups.advertiser.length !==
        this.selectedLocationGroups.length
      )
        return false
      return true
    },
    isAllInsertionOrderLocationGroupsSelected() {
      if (this.filteredSelectableLocationGroups.insertionOrder.length === 0)
        return false
      if (
        this.filteredSelectableLocationGroups.insertionOrder.length !==
        this.selectedLocationGroups.length
      )
        return false
      return true
    },
    isAllDeliveryLocationGroupsSelected() {
      if (this.filteredDeliveryLocationGroups.length === 0) return false
      if (
        this.filteredDeliveryLocationGroups.length !==
        this.selectedDeliveryLocationGroups.length
      )
        return false
      return true
    },
    // 検索機能
    // 検索機能とhtml操作の関係
    //
    // - searchBoxIndex（検索機能のインデックス） -
    // 0: selectableLocationGroupsの検索機能
    // 1: deliveryLocationGroupsの検索機能
    //
    // - refs名 -
    // "selector(数字1)(数字2)"
    // "option(数字1)(数字2)"
    // 数字1: searchBoxIndex
    // 数字2: tabのindex(selectableLocationGroupsの検索機能の時)

    inputKeyword: debounce(function(searchBoxIndex) {
      this[`searchIndex${searchBoxIndex}`] = 0
      this.search(searchBoxIndex)
    }, 1000),
    search(searchBoxIndex) {
      this.putOnHighLightTag(searchBoxIndex)
      this.scroll(searchBoxIndex, 0)
      this[`searchCount${searchBoxIndex}`] = document.getElementsByClassName(
        `has-keyword-${searchBoxIndex}`,
      ).length
    },
    putOnHighLightTag(searchBoxIndex) {
      const spanTagStart = '<span style="background-color: #fddb67;">'
      const spanTagEnd = '</span>'
      const optionRef =
        searchBoxIndex === 0
          ? `option${searchBoxIndex}${this.activeTab}`
          : `option${searchBoxIndex}`

      if (this.$refs[optionRef] === undefined) return
      this.$refs[optionRef].forEach(option => {
        // spanタグがあれば、取り除く
        const spanTagEndRE = new RegExp(spanTagEnd, 'g')
        option.innerHTML = option.innerHTML.replace(
          /<span style="background-color: #[0-9a-fA-F]+;">/,
          '',
        )
        option.innerHTML = option.innerHTML.replace(spanTagEndRE, '')
        option.classList.remove(`has-keyword-${searchBoxIndex}`)
        // 検索ワードをspanタグで囲む
        if (this[`keyword${searchBoxIndex}`]) {
          const keywordRE = new RegExp(this[`keyword${searchBoxIndex}`])
          if (option.innerHTML.match(keywordRE)) {
            option.innerHTML = option.innerHTML.replace(
              keywordRE,
              `${spanTagStart}${this[`keyword${searchBoxIndex}`]}${spanTagEnd}`,
            )
            option.classList.add(`has-keyword-${searchBoxIndex}`)
          }
        }
      })
    },
    clearKeyword(searchBoxIndex) {
      this[`keyword${searchBoxIndex}`] = ''
      this[`searchIndex${searchBoxIndex}`] = null
      this[`searchCount${searchBoxIndex}`] = null
    },
    scroll(searchBoxIndex, index, shiftIndex) {
      const selectorEl =
        searchBoxIndex === 0
          ? this.$refs[`selector${searchBoxIndex}${this.activeTab}`][0]
          : this.$refs[`selector${searchBoxIndex}`]

      selectorEl.scrollTop = 0
      const searchElement = document.getElementsByClassName(
        `has-keyword-${searchBoxIndex}`,
      )[index]
      // 移動前のindex
      const preventIndex =
        (index + this[`searchCount${searchBoxIndex}`] - shiftIndex) %
        this[`searchCount${searchBoxIndex}`]
      const preventSearchElement = document.getElementsByClassName(
        `has-keyword-${searchBoxIndex}`,
      )[preventIndex]
      if (searchElement) {
        searchElement.innerHTML = searchElement.innerHTML.replace(
          '#fddb67', // 黄色
          '#ff7e41', // オレンジ
        )
        if (this[`searchCount${searchBoxIndex}`] != 1 && preventSearchElement)
          preventSearchElement.innerHTML = preventSearchElement.innerHTML.replace(
            '#ff7e41', // オレンジ
            '#fddb67', // 黄色
          )
        selectorEl.scrollTop =
          searchElement.getBoundingClientRect().top -
          selectorEl.getBoundingClientRect().top
      }
    },
    shiftSearchItem(searchBoxIndex, number) {
      this[`searchIndex${searchBoxIndex}`] =
        (this[`searchIndex${searchBoxIndex}`] +
          this[`searchCount${searchBoxIndex}`] +
          number) %
        this[`searchCount${searchBoxIndex}`]
      this.scroll(searchBoxIndex, this[`searchIndex${searchBoxIndex}`], number)
    },
  },
}
</script>

<style scoped lang="scss">
.select-box {
  width: 100%;
  height: 150px;
  border: 1px solid black;
  position: relative;
}
.select-box::after {
  border-right: solid 1px gainsboro;
  position: absolute;
  content: '';
  display: block;
  top: 0;
  bottom: 0;
  right: 33.33333333333333%;
}
.locationGroupList {
  height: 100%;
  overflow-y: scroll;
}
.locationGroup {
  cursor: pointer;
  &.isSelected {
    background-color: rgba(#1976d2, 0.6);
  }
  display: flex;
}
.locationGroup.isSimulation::before {
  font-family: 'Material Icons';
  content: '\e061';
  color: #0baaf6;
  font-size: 15px;
  margin-top: 2px;
  padding-left: 3px;
  padding-right: 3px;
  display: block;
  float: left;
}
.locationGroup.added:not(.isSimulation) {
  padding-left: 21px;
}
.location-group-name {
  overflow-x: hidden;
}
.location-group-type {
  text-align: center;
}
.location-group-list {
  padding: 14px 0 0 0;
}
.location-group-list-add {
  padding: 14px 0 3px 0;
}
.subheader {
  color: rgba(0, 0, 0, 0.54);
  display: inline-block;
  font-size: 14px;
  font-weight: 500;
}
.group-filter {
  align-items: center;
}
.location-group-buttons {
  font-size: 12px;
  display: inline-block;
  text-align: right !important;
}
.location-group-button {
  display: inline-block;
  cursor: pointer;
  padding: 3px 6px;
  &:hover {
    background-color: #d7eeff;
  }
}
.location-group-button-text {
  color: #1976d2;
  margin-left: 5px;
}
.location-group-button-refresh {
  margin-left: 5px;
}
.simulation-point-icon {
  font-size: 14px;
  color: #0baaf6;
}
.search-box-layer {
  padding-bottom: 5px;
  justify-content: flex-end;
}
.search-box {
  min-height: 0;
  max-height: 40px;
  display: inline-block;
  color: black !important;
}
</style>
